namespace GeniuzPOS.Common.Report {
    export interface BaseReportHeader extends Serenity.ListRequest {
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
